/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The tariff constraint is the paid period.
 */
export interface TariffConstraintLastmile { 
    /**
     * Length of the paid period, minute for the performer, meters for the transport.
     */
    stage_length: number;
    /**
     * Cost within the paid period. For the performer - monetary unit per minute of work. For the transport - monetary unit per meter of track. 
     */
    cost_per_unit: number;
}

